var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h70.8v70.8H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.605 21.751a9.153 9.153 0 0 1 9.145-9.145h11.8V7h-11.8a14.751 14.751 0 0 0 0 29.5h11.8v-5.6h-11.8a9.153 9.153 0 0 1-9.145-9.149zM19.7 24.7h23.6v-5.9H19.7zM46.252 7h-11.8v5.605h11.8a9.145 9.145 0 1 1 0 18.291h-11.8V36.5h11.8a14.751 14.751 0 0 0 0-29.5z",
    transform: "translate(3.9 13.651)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkFilled);
export default __webpack_public_path__ + "static/media/link-filled.184e94f9a779f4027a7cf9ad05cff280.svg";
export { ForwardRef as ReactComponent };